/* eslint-disable react/prop-types */
import React, { Component } from "react";
import "../../assets/styles/App.css";
import "../../assets/styles/Login.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { backendBaseUrl } from "../../config";
import { unblockEmail } from "../../constants/endpoints";
import { postUnauthenticatedData } from "../../utils/async";
import { toast } from "react-toastify";
import history from "../../utils/history";

export default class Recover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: true,
      cameFromPasswordPage: this.props.location.cameFromPasswordPage,
      disableButton: false
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onSubmit() {
    this.setState({ disableButton: true });
    postUnauthenticatedData(
      backendBaseUrl + unblockEmail + "/" + this.props.location.email,
      {}
    ).then(result => {
      this.setState({ disableButton: false });
      history.push("/login");
      if (result.status == 200) {
        toast.success("The admin has been informed of your unblock request.");
      } else {
        toast.error("Something Went Wrong");
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    const MainText = () => {
      if (this.state.cameFromPasswordPage) {
        return (
          <p className="centerrecover">
            Your account has been locked after multiple unsuccessful attempts.
          </p>
        );
      } else {
        return <p className="centerrecover">Your account is suspended.</p>;
      }
    };
    return (
      <div className="Login">
        <form className="loginpad1" onSubmit={this.handleSubmit}>
          <p className="imgcenter">
            <img
              className="loginlogo"
              src={require("../../assets/images/remidio.png")}
            />
          </p>
          <MainText></MainText>
          <div>
            <Button
              block
              bsSize="large"
              onClick={this.onSubmit}
              type="submit"
              className="loginbtn"
            >
              {this.state.disableButton ? (
                <img src={require("../../assets/images/button-loading.gif")} />
              ) : (
                "Recover Account"
              )}
            </Button>
          </div>
          <Link to="/">
            <p className="backrecover">Back</p>
          </Link>
        </form>
      </div>
    );
  }
}
